import { createContext, useContext } from "react";

import type { StreamStatus } from "../api/events";

/** The team stream's status, provided by the team layout, which owns the one stream. */
export const StreamStatusContext = createContext<StreamStatus | undefined>(undefined);

/**
 * Whether the team's events are arriving: `live`, `connecting` or `reconnecting`; `undefined`
 * outside a team's pages. A screen that relies on events refetches by itself while it is not
 * `live`, since a stream can drop (F3 retries it with backoff).
 */
export function useStreamStatus(): StreamStatus | undefined {
  return useContext(StreamStatusContext);
}
